import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Stack } from "@mui/material";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CachedIcon from "@mui/icons-material/Cached";

import NotificationTable from "./component/T_Notification";
import NotificationModal from "./component/M_Notification";
import useAuth from "../../../hooks/useAuth";
import useGeneral from "../../../hooks/super/useGeneral";

import { CollapseAlert } from "../../../components/pages/common/styled";
import { UserType } from "../../../utils/constants";

import PageHeader from "../../../components/pages/_new/super/common/PageHeader";
import PrimaryButton from "../../../components/pages/_new/super/common/PrimaryButton";
import OutlinedButton from "../../../components/pages/_new/super/common/OutlinedButton";

function SANotificationConfiguration() {
  const { notifications, getNotifications, size, errMsg, setErr } = useGeneral();
  const { isAuthenticated, adminUserType } = useAuth();

  const [errOpen, setErrOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const refresh = () => getNotifications(size, 0);

  React.useEffect(() => {
    if (isAuthenticated) getNotifications(size, 0);
    return () => setErr(null);
  }, [isAuthenticated, getNotifications, size, setErr]);
  React.useEffect(() => {
    if (errMsg) setErrOpen(true);
  }, [errMsg]);

  const canEdit = [UserType.SUPER_ADMIN, UserType.ADMIN].includes(adminUserType);

  return (
    <React.Fragment>
      <Helmet title="SA Global Notifications" />
      <PageHeader
        title="Global Notifications"
        description="Banner notifications shown across all tenant dashboards"
        actions={
          <>
            <OutlinedButton onClick={refresh} startIcon={<CachedIcon style={{ width: 18, height: 18 }} />}>
              Refresh
            </OutlinedButton>
            <PrimaryButton
              onClick={handleOpen}
              startIcon={<AddCircleOutlineIcon style={{ width: 18, height: 18 }} />}
              disabled={!canEdit || !notifications}
            >
              Add Notification
            </PrimaryButton>
          </>
        }
      />
      <Box sx={{ mb: 3 }}>
        <CollapseAlert errOpen={errOpen} setErrOpen={setErrOpen} setErr={setErr} errMsg={errMsg} />
      </Box>

      <Stack spacing={2}>
        <NotificationTable />
      </Stack>
      <NotificationModal open={open} handleClose={handleClose} />
    </React.Fragment>
  );
}
export default SANotificationConfiguration;
